export const STORE_INFO = {
  name: 'Basmati Grocers',
  address: '2436 S I-35, Suite# 330, Denton, TX',
  phone: '940-435-0196',
  email: 'contact@basmatigrocers.com',
  hours: '10AM to 10PM',
  daysOpen: '7 days a week',
  cafeUrl: 'https://basmati-cafe-denton.square.site/'
};

export const THEME_COLORS = {
  primary: '#568203', // Avocado green
  secondary: '#2F4203',
  accent: '#8B9D77'
};